import React from 'react'
import { Button } from 'antd'
import './index.scss'

interface ButtonSquareProps {
  icon?: React.ReactNode | string | null;
  iconType?: 'svg' | 'png' | 'element';
  loading?: boolean;
  disabled?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  holderStyles?: React.CSSProperties;
  buttonStyles?: React.CSSProperties;
  onClick?: () => void;
  ariaLabel?: string;
}

const ButtonSquare: React.FC<ButtonSquareProps> = ({
  icon = null,
  iconType = 'element',
  loading = false,
  disabled = false,
  htmlType = 'button',
  holderStyles = {},
  buttonStyles = {},
  onClick = () => {},
  ariaLabel = '',
}) => {
  const renderIcon = () => {
    if (!icon) return null

    if (iconType === 'svg' || iconType === 'png') {
      const iconPath = icon as string
      return (
        <div
          className="button-square-icon"
          style={{
            '--icon-url': `url('${iconPath}')`,
          } as React.CSSProperties}
        />
      )
    }

    return icon as React.ReactNode
  }

  return (
    <div style={holderStyles} className="button-holder-square">
      <Button
        type="primary"
        htmlType={htmlType}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        style={buttonStyles}
        aria-label={ariaLabel}
        className="button-square"
      >
        {renderIcon()}
      </Button>
    </div>
  )
}

export default ButtonSquare
